import { SCKpis } from "../generic/generic-sc-domain";
import { RoleEnum } from "./salescredit-role-types";

export interface ISCRoleDictionary {
  GetKpi(role: string, kpi: string): string;
}

export class SCRoleDictionary implements ISCRoleDictionary {
  private readonly kpis: {
    [role: string]: { kpis: { [kpi: string]: string } };
  };

  public constructor() {
    this.kpis = {};
    this.kpis[RoleEnum.MANAGER] = { kpis: {} };

    this.kpis[RoleEnum.MANAGER].kpis[SCKpis.SC_BUDGET] = SCKpis.SC_BUDGET;
    this.kpis[RoleEnum.MANAGER].kpis[SCKpis.SC_BUDGET_PRORATA] =
      SCKpis.SC_BUDGET_PRORATA;
  }

  public GetKpi(role: string, kpi: string): string {
    if (this.kpis[role] === undefined || this.kpis[role].kpis === undefined) {
      return kpi;
    }
    if (this.kpis[role].kpis[kpi] === undefined) {
      return kpi;
    }
    return this.kpis[role].kpis[kpi];
  }
}
